"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDingTalkLite = exports.isMobile = exports.isXueXi = exports.isPCDingTalk = exports.isIOSDingTalk = exports.isIOS = exports.isAndroidDingTalk = exports.isAndroid = exports.isWeixin = exports.isInDingTalk = void 0;
/* tslint:disable:max-line-length */
/**
 * 相较于V1版本，为了性能以及与服务端命名保持一致，此版本更新为
 * 导出 变量 => 方法
 */
var env_1 = require("../lib/env");
var isDingTalkLite_1 = require("@ali/dingtalk-kit/lib/apis/miniProgram/platform/isDingTalkLite");
var isDingTalkLite_2 = require("@ali/dingtalk-kit/lib/apis/webview/platform/isDingTalkLite");
var isDingTalkLite_3 = require("@ali/dingtalk-kit/lib/apis/weex/platform/isDingTalkLite");
var dingtalkEnv = env_1.getENV();
var lowerUA = env_1.getUA().toLocaleLowerCase();
/** 判断是否是在DingTalk容器内 */
exports.isInDingTalk = function () {
    return dingtalkEnv.platform !== env_1.ENV_ENUM.notInDingTalk;
};
/** 判断是否在微信终端 */
exports.isWeixin = function () {
    return lowerUA.indexOf('micromessenger') !== -1;
};
/** 判断是否是android终端 */
exports.isAndroid = function () {
    return lowerUA.indexOf('android') !== -1 || lowerUA.indexOf('adr') !== -1;
};
/** 判断是否在android Dingtalk环境下 */
exports.isAndroidDingTalk = function () {
    return dingtalkEnv.platform === env_1.ENV_ENUM.android;
};
/** 判断是否是iOS终端 */
exports.isIOS = function () {
    return !!lowerUA.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/i);
};
/** 判断是否在iOS Dingtalk环境下 */
exports.isIOSDingTalk = function () {
    return dingtalkEnv.platform === env_1.ENV_ENUM.ios;
};
/** 判断是否在PC Dingtalk环境下 */
exports.isPCDingTalk = function () {
    return dingtalkEnv.platform === env_1.ENV_ENUM.pc;
};
/** 判断是否是XueXi客户端下 */
exports.isXueXi = function () {
    return lowerUA.indexOf('device/xuexi') !== -1;
};
/** 判断是否是移动终端 */
exports.isMobile = function () {
    return exports.isIOSDingTalk() || exports.isAndroidDingTalk() ||
        /phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone/i.test(lowerUA);
};
/** 判断是否是钉钉国际版 */
exports.isDingTalkLite = function () {
    return isDingTalkLite_1.isDingTalkLite() || isDingTalkLite_2.isDingTalkLite() || isDingTalkLite_3.isDingTalkLite();
};
